// src/screens/ForgotPasswordScreen.js

import React, { useState } from 'react';
import { Container, Form, Button, Alert, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import api from '../services/api';

const ForgotPasswordScreen = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      // This POST request hits your backend route: /api/users/forgot-password
      const { data } = await api.post('/auth/forgot-password', { email });
      setLoading(false);
      setMessage(data.message); // Show the success message from the backend
    } catch (err) {
      setLoading(false);
      // We show the generic success message even on error for security
      setMessage("If an account with that email exists, a reset link has been sent.");
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
      <div style={{ width: '100%', maxWidth: '450px' }}>
        <Card>
          <Card.Body>
            <Card.Title as="h3" className="text-center mb-4">Forgot Password</Card.Title>
            <Card.Text className="text-muted text-center mb-4">
              Enter your email and we will send you a link to reset your password.
            </Card.Text>
            
            {message && <Alert variant="success">{message}</Alert>}
            {error && <Alert variant="danger">{error}</Alert>}
            
            {!message && ( // Hide form after message is shown
              <Form onSubmit={submitHandler}>
                <Form.Group className="mb-3" controlId="email">
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </Form.Group>

                <div className="d-grid">
                  <Button variant="primary" type="submit" disabled={loading}>
                    {loading ? 'Sending...' : 'Send Reset Link'}
                  </Button>
                </div>
              </Form>
            )}

            <div className="text-center mt-3">
              <Link to="/">Back to Login</Link>
            </div>
          </Card.Body>
        </Card>
      </div>
    </Container>
  );
};

export default ForgotPasswordScreen;